// removed by extract-text-webpack-plugin
module.exports = {"termsServiceWrap":"qempo_TermsService_termsServiceWrap-2Mq1gqq"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/terms-service/components/TermsService.scss
// module id = 1972
// module chunks = 0